import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const ElementsIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.092.001a.76.76 0 0 0-.625.424l-2.525 4.792-2.534 4.791a.902.902 0 0 0-.003.836c.136.26.388.42.662.42H23.2a.756.756 0 0 0 .661-.42.902.902 0 0 0-.003-.836l-2.533-4.791L18.8.425a.753.753 0 0 0-.708-.424zM3.733.043A3.74 3.74 0 0 0 0 3.77v4.259a3.74 3.74 0 0 0 3.733 3.726H8a3.74 3.74 0 0 0 3.733-3.726v-4.26A3.74 3.74 0 0 0 8 .044H3.733zm0 1.597H8a2.11 2.11 0 0 1 2.133 2.13v4.259A2.11 2.11 0 0 1 8 10.159H3.733A2.11 2.11 0 0 1 1.6 8.028v-4.26A2.11 2.11 0 0 1 3.733 1.64zm14.4.873 1.875 3.536 1.859 3.535H14.4l1.858-3.535 1.875-3.536zM5.867 12.288C2.637 12.288 0 14.919 0 18.144S2.636 24 5.867 24c3.23 0 5.866-2.631 5.866-5.856s-2.636-5.856-5.866-5.856zm10.133 0a3.74 3.74 0 0 0-3.733 3.726v4.26A3.74 3.74 0 0 0 16 24h4.267A3.74 3.74 0 0 0 24 20.273v-4.259a3.74 3.74 0 0 0-3.733-3.726H16zM5.867 13.885a4.25 4.25 0 0 1 4.266 4.259 4.25 4.25 0 0 1-4.266 4.259 4.25 4.25 0 0 1-4.267-4.26 4.25 4.25 0 0 1 4.267-4.258zm10.133 0h4.267a2.11 2.11 0 0 1 2.133 2.13v4.258a2.11 2.11 0 0 1-2.133 2.13H16a2.11 2.11 0 0 1-2.133-2.13v-4.259A2.11 2.11 0 0 1 16 13.884z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

ElementsIcon.propTypes = propTypes;

export default ElementsIcon;
